import type {UpdateLeadFormPayload} from "./update-lead.schema";

import {updateLead} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {leadKeys, leadMutationKeys} from "../../../lead-keys";

import {updateLeadMapper} from "./update-lead.mapper";

export function updateLeadMutationOptions(leadId: string) {
  return mutationOptions({
    mutationFn: (payload: UpdateLeadFormPayload) => {
      const request = updateLeadMapper.toSdk(payload);

      return updateLead(leadId, request);
    },
    mutationKey: leadMutationKeys.updateLead,
    onSuccess: async (_data, _payload, _onMutateResult, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: leadKeys.detail(leadId)}),
        client.invalidateQueries({queryKey: leadKeys.lists()}),
      ]);
    },
  });
}
